import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import ChatMessage from "./ChatMessage";
import { askQuestion, chatHistory } from "../../app/actions/chat";
import { useDispatch } from "react-redux";

const style = {
  position: "absolute",
  top: "20%",
  left: "50%",
  transform: "translate(-50%, -20%)",
  width: "60%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  fontFamily: "Fira Sans",
  p: 4,
};

const boxStyle = {
  minHeight: "200px",
  maxHeight: "600px",
  overflowY: "scroll",
};

export default function ChatModal({ documentId }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(chatHistory(documentId))
      .then((response) => {
        const { data } = response;
        const { data: chat_history } = data;

        chat_history.map((chat_item) => {
          const { question, answer } = chat_item;
          setMessages((prevMessages) => [
            ...prevMessages,
            { source: "user", content: question },
            { source: "assistant", content: answer },
          ]);
        });
      })
      .catch((error) => {});
  }, []);

  const handleSubmit = async () => {
    const prompt = {
      source: "user",
      content: input,
    };

    const data = {
      document_id: documentId,
      question: input,
    };

    setMessages([...messages, prompt]);
    setInput("");

    dispatch(askQuestion(data))
      .then((response) => {
        const { data } = response;
        const { data: chat } = data;
        const { answer } = chat;
        setMessages((messages) => [
          ...messages,
          {
            source: "assistant",
            content: answer,
          },
        ]);
      })
      .catch((error) => {});
  };
  return (
    <div>
      <Button onClick={handleOpen} variant="contained" color="primary">
        Chat with Facilitr AI
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h1"
            style={{ fontSize: "42px" }}
          >
            Facilitr AI
          </Typography>
          <div className="Content" style={boxStyle}>
            {messages.map((el, i) => {
              return (
                <ChatMessage key={i} source={el.source} content={el.content} />
              );
            })}
          </div>
          <div>
            <TextField
              value={input}
              placeholder="Type here..."
              onChange={(e) => setInput(e.target.value)}
            />
            <Button
              onClick={input ? handleSubmit : undefined}
              variant="contained"
              color="primary"
            >
              Send
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
